import { createReducer } from "redux-act";
import { PURGE } from "redux-persist";
import customIsoString from "utilities/custom-iso-string";

import {
    descriptionUpdate,
    noteUpdate,
    dateUpdate,
    subjectUpdate,
    typeUpdate,
    markUpdate,
    imageUpdate,
    linkEventHomework,
    loadExistingHomework,
    directInputUpdate,
    directInputSwitcherUpdate,
    resetHomework,
    timeslotUpdate,
    directlyCreateTaskUpdate
} from "actions/new-homework";

const defaultState = {
    description: "",
    type: "make",
    date: customIsoString(new Date()).split("T")[0], //remove time from date object
    subject: null,
    time: 10,
    note: "",
    image: null,
    mark: false,
    directlyCreateTask: false,
    showDirectInput: false,
    showDirectInputSwitcher: false,
    editing: false,
    timeslot: 0,
    event: {}
};

const newHomework = createReducer(
    {
        [descriptionUpdate]: (state, payload) => ({
            ...state,
            description: payload.description
        }),
        [noteUpdate]: (state, payload) => ({
            ...state,
            note: payload.note
        }),

        [dateUpdate]: (state, payload) => ({
            ...state,
            date: payload.date
        }),
        [subjectUpdate]: (state, payload) => ({
            ...state,
            subject: payload.subject
        }),
        [typeUpdate]: (state, payload) => ({
            ...state,
            type: payload.type
        }),
        [markUpdate]: (state, payload) => ({
            ...state,
            mark: payload.mark
        }),
        [imageUpdate]: (state, payload) => ({
            ...state,
            image: payload.image
        }),
        [linkEventHomework]: (state, payload) => ({
            ...state,
            event: payload.event
        }),
        [timeslotUpdate]: (state, payload) => ({
            ...state,
            timeslot: payload.timeslot
        }),
        [loadExistingHomework]: (state, payload) => ({
            ...state,
            ...payload.homework,
            editing: true,
            subject: payload.homework.user_subject_id,
            note: payload.homework.note ? payload.homework.note : "",
            timeslot: payload.homework.timeslot
        }),
        [directlyCreateTaskUpdate]: (state, payload) => ({
            ...state,
            directlyCreateTask: payload.value
        }),
        [directInputUpdate]: (state, payload) => ({
            ...state,
            showDirectInput: payload.directInput
        }),
        [directInputSwitcherUpdate]: (state, payload) => ({
            ...state,
            showDirectInputSwitcher: payload.directInputSwitcher
        }),

        [resetHomework]: () => defaultState,
        [PURGE]: () => defaultState
    },
    defaultState
);

export default newHomework;
